@if (sMenu) {
<div class="sidebar" [ngStyle]="{ display: activateGlobalNav ? 'none' : 'block' }">
  @if (!isResponsiveScreen && sMenu.navigationMenuTitle) {
  <div class="back-link">
    <a [routerLink]="sMenu.navigationMenuPath">
      <button-icon iconattributes="-xsm" [icon]="'singlearrow-left'" class="navigation-back-icon"></button-icon>
      <span class="navigation-title">{{ sMenu.navigationMenuTitle }}</span>
    </a>
  </div>
  }
  @if (isResponsiveScreen && getBackTitle()) {
      <div class="back-link" (click)="goBack()">
        <button-icon class="navigation-back-icon" iconattributes="-xsm"
          [icon]="'singlearrow-left'"></button-icon>
        <span class="navigation-responsive-title">{{ getBackTitle() }}</span>
      </div>
  }
  @if (isResponsiveScreen && previousMenus.length > 0 && sMenu.title) {
    <div class="section-heading">
      <span class="item-title">{{ sMenu.title }}</span>
    </div>
  }
  @for (section of sMenu.children; track section) {
    <div class="category-container" [ngClass]="{ 'drilled-category': isResponsiveScreen && isToggled }">
      <div class="category">
        @if ((!section.path && !isResponsiveScreen) || (!isToggled && previousMenus.length === 0)) {
        <span>{{ section.title }}</span>
        } @if (section.path && isToggled) {
        <app-link class="category-link" [to]="section.path" [disableRoute]="!section.path">
          @if (section.icon) {
          <lucide-icon [name]="section.icon" class="lucide-icon"></lucide-icon>
          }
          <span class="category-link-title">{{ section.title }}</span>
        </app-link>
        }
      </div>
      <ul class="section-items parent-category">
        <ng-container *ngTemplateOutlet="renderItems; context: { items: section.children }"></ng-container>
      </ul>
    </div>
  }
  <ng-template #renderItems let-items="items">
    @for (item of items; track item) {
      <li>
        <div class="item-row" [ngClass]="{ 'expandable': item.children }"
          (click)="item.children && toggle(item, $event)">
          @if (item.path) {
            <app-link class="item-link" [to]="item.path" [disableRoute]="!item.path"
              (click)="onSelectGrandchild(item, $event)">
              @if (item.icon) {
                <lucide-icon [name]="item.icon" class="lucide-icon"></lucide-icon>
              }
              <span class="item-title" [ngClass]="getTitleClass(item)">
                {{ item.title }}
              </span>
            </app-link>
          }
          @if (!item.path && item.children) {
            <span class="item-title has-children"
              [ngClass]="[getTitleClass(item), item.expanded ? 'expanded' : '']">
              {{ item.title }}
            </span>
          }
          @if (item.children) {
            <button-icon class="category-icon" iconattributes="-xsm"
              [icon]="item.expanded ? 'dropdown' : 'singlearrow-right'"
              (click)="toggle(item, $event)">
            </button-icon>
          }
        </div>
        @if (item.expanded && item.children) {
          <ul class="child-items">
            <ng-container
              *ngTemplateOutlet="renderItems; context: { items: item.children }"></ng-container>
          </ul>
        }
      </li>
    }
  </ng-template>
</div>
}
@if (activateGlobalNav) {
<div class="global-nav-container" [ngStyle]="{ display: activateGlobalNav ? 'block' : 'none' }">
  <app-nav-container
    [menu]="globalNav"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"></app-nav-container>
</div>
}